import { FastRepliesHotKey, hotKeyEmpty, HotKeyValues } from "../../../models/fastRepliesHotKeys"
import keycode from "keycode"

export const toHotKeyValues = (hotKey?: FastRepliesHotKey): HotKeyValues => {
    return hotKey
        ? {
              FirstKey: keycode(hotKey.FirstKey).toUpperCase(),
              SecondKey: getSecondCombinationChar(hotKey?.CombinationName).toUpperCase()
          }
        : hotKeyEmpty
}

export const getSecondCombinationChar = (combinationName = ""): string => {
    const separatorIndex = combinationName.indexOf("+")

    if (separatorIndex === -1) {
        return ""
    }

    return combinationName.substring(separatorIndex + 1)
}
